import { DeviceGroupPolicyVaultOperation } from '../vault/device-group-policy-vault/device-group-policy-vault-operation';
import { DeviceGroupVaultOperation } from '../vault/device-group-vault/device-group-vault-operation';
export class InitializeService {
    constructor(uiFrameAdapter, deviceGroupService, deviceGroupPolicyService, logger) {
        this.uiFrameAdapter = uiFrameAdapter;
        this.deviceGroupService = deviceGroupService;
        this.deviceGroupPolicyService = deviceGroupPolicyService;
        this.logger = logger;
    }
    async initialize(signingContext) {
        if (!await this.deviceGroupService.isDeviceGroupVaultInitialized(this.uiFrameAdapter.companyId)) {
            await this.initializeDeviceGroup(signingContext);
        }
        if (!await this.deviceGroupPolicyService.isDeviceGroupPolicyVaultInitialized(this.uiFrameAdapter.companyId)) {
            await this.initializeDeviceGroupPolicy(signingContext);
        }
    }
    async initializeDeviceGroup(signingContext) {
        try {
            await this.deviceGroupService.addDeviceGroupVaultEntry(null, null, null, this.uiFrameAdapter.userId, DeviceGroupVaultOperation.NoOp, signingContext);
        }
        catch (ex) {
            this.logger.logError(`Device Group Vault: ${ex}`);
            throw ex;
        }
    }
    async initializeDeviceGroupPolicy(signingContext) {
        try {
            await this.deviceGroupPolicyService.addDeviceGroupPolicyVaultEntry(null, DeviceGroupPolicyVaultOperation.NoOp, null, null, null, null, null, this.uiFrameAdapter.userId, signingContext);
        }
        catch (ex) {
            this.logger.logError(`Device Group Policy Vault: ${ex}`);
            throw ex;
        }
    }
}
